import * as tslib_1 from "tslib";
import React from 'react';
import Dialog from './Dialog';
var PageDialog = /** @class */ (function (_super) {
    tslib_1.__extends(PageDialog, _super);
    function PageDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { container: undefined };
        return _this;
    }
    PageDialog.prototype.componentDidMount = function () {
        var container = document.querySelector('.sinoui-page-content.sinoui-page-content__shown');
        this.setState({
            container: container,
        });
    };
    PageDialog.prototype.render = function () {
        return this.state.container ? (React.createElement(Dialog, tslib_1.__assign({ container: this.state.container }, this.props))) : null;
    };
    return PageDialog;
}(React.Component));
export default PageDialog;
//# sourceMappingURL=PageDialog.js.map